import { TokenBase } from "~/types";
import { getSafeAreaInsetBottom } from "~/components/widget/SafeAreaBottom/SafeAreaBottom";
import { IconWalletLogo } from "~/components/Iconfont/Iconfont";
import { formatBalance } from "~/utils/number-format";
import { useTranslation } from "react-i18next";

type BalanceInfoProps = {
    fromTokenBase: TokenBase;
    fromBalance: number | string;
};

const BalanceInfo: React.FC<BalanceInfoProps> = ({
    fromTokenBase,
    fromBalance,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="h-[52px]" />
            <div
                style={{
                    bottom: `calc(${getSafeAreaInsetBottom()} + 3.375rem)`,
                }}
                className="flex items-center fixed h-[52px] w-full border-t-[0.5px] border-border_2 px-4"
            >
                <div className="bg-text_brand rounded-full mr-2">
                    <IconWalletLogo className="text-text_brand text-[32px]" />
                </div>
                <div className="flex flex-col">
                    <span className="text-text_2 text-body4">
                        {t("your_balance")}
                    </span>
                    <span className="text-text_1 text-body2 font-semibold">
                        {formatBalance(fromBalance)}{" "}
                        {fromTokenBase.symbol.toUpperCase()}
                    </span>
                </div>
            </div>
        </>
    );
};

export default BalanceInfo;
